import { graphql } from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import { trackAndCommitMutation } from '../../tracking/amplitude/TrackMutation';
const mutation = graphql `
	mutation UnassignPersonFromTaskMutation($input: UnassignPersonFromTaskInput!) {
		unassignPersonFromTask(input: $input) {
			task {
				id
				assignedPersons {
					id
				}
			}
		}
	}
`;
// Imperative updater since assignedPersons does not follow relay connection paradigm. With a connection, RANGE_DELETE would be usable instead.
// Alternatively could pass in full list of assignees and manipulate with standard optimistic updater, but feels more correct to allow mutation to run in isolation.
const optimisticUpdater = (input, store) => {
    var _a;
    if (!input.taskId || !input.personId)
        return;
    const taskNode = store.get(input.taskId);
    const existingAssignedPersons = (_a = taskNode === null || taskNode === void 0 ? void 0 : taskNode.getLinkedRecords('assignedPersons')) !== null && _a !== void 0 ? _a : [];
    const removedAssignedPerson = store.get(input.personId);
    if (removedAssignedPerson) {
        const newAssignedPersons = existingAssignedPersons.filter(personRecord => personRecord !== removedAssignedPerson);
        taskNode === null || taskNode === void 0 ? void 0 : taskNode.setLinkedRecords(newAssignedPersons, 'assignedPersons');
    }
};
function commit(environment, input, onSuccess, onError) {
    const mutationConfig = {
        mutation,
        variables: { input: Object.assign({ csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId() }, input) },
        optimisticUpdater: store => optimisticUpdater(input, store),
        onCompleted: onSuccess,
        onError: onError,
    };
    return trackAndCommitMutation(environment, mutationConfig);
}
export default { commit };
